function styleToStr (obj) {
  return Object.entries(obj).map((item) => {
    // const splitIdx = key.indexOf('-');
    // if (splitIdx !== -1) {
    //     key = key.split('');
    //     key.splice(splitIdx, 2, key[splitIdx + 1].toUpperCase());
    //     key = key.join('');
    // }

    return `${item[0]}: ${item[1]}`;
  }, '').join(';');
}

function shareModel (cb) {
  const id = Math.random();
  const fragment = document.createDocumentFragment();
  const container = document.createElement('div');
  container.id = id;
  const content = document.createElement('div');
  content.style.cssText = styleToStr({
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    height: '100%',
    'z-index': 99999,
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    transform: 'translateZ(1px)',
    'flex-direction': 'column',
    'font-size': '18px',
    color: '#fff'
  });
  const text = document.createElement('div');
  text.style.cssText = styleToStr({
    'font-weight': 'bold'
  });
  text.innerText = '请点击右上角分享';
  const btn = document.createElement('div');
  btn.style.cssText = styleToStr({
    'margin-top': '15px',
    height: '40px',
    'line-height': '40px',
    width: '150px',
    background: '#fff',
    color: '#000',
    'border-radius': '5px',
    border: '1px #ddd solid',
    'text-align': 'center'
  });
  btn.innerText = '我知道了';
  const mask = document.createElement('div');
  mask.style.cssText = styleToStr({
    position: 'fixed',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    height: '100%',
    'z-index': 999,
    'background-color': 'rgba(0, 0, 0, .75)'
  });
  content.append(text);
  content.append(btn);
  container.append(content);
  container.append(mask);
  fragment.append(container);
  document.body.append(fragment);

  const hideHandle = () => {
    const container = document.getElementById(id);
    container && document.body.removeChild(container);
  };

  btn.onclick = () => {
    hideHandle();
    cb();
  };
  return hideHandle;
}

export default shareModel;
